import { render, staticRenderFns } from "./TopicCreate.vue?vue&type=template&id=52b2e231&scoped=true&"
import script from "./TopicCreate.vue?vue&type=script&lang=js&"
export * from "./TopicCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2e231",
  null
  
)

export default component.exports